<div class="nav-menu__container">

  <a mat-flat-button routerLink="/lots/actual">
    <mat-icon>gavel</mat-icon>
    <span class="nav-menu__link-text">Лоты</span>
  </a>
  <a *ngIf="api.getAccess('requests')" mat-flat-button routerLink="/accreditation">
    <mat-icon>security</mat-icon>
    <span class="nav-menu__link-text">Аккредитация</span>
  </a>
  <a *ngIf="api.user" mat-flat-button routerLink="/profile">
    <mat-icon>contact_mail</mat-icon>
    <span class="nav-menu__link-text">Мои данные</span>
  </a>
  <a *ngIf="api.getAccess('messages')" mat-flat-button mat-flat-button routerLink="/messages/messages">
    <mat-icon>notifications</mat-icon>
    <span class="nav-menu__link-text">Уведомления</span>
  </a>
  <a *ngIf="api.getAccess('listusersections')" mat-flat-button routerLink="/users/list">
    <mat-icon>group</mat-icon>
    <span class="nav-menu__link-text">Пользователи</span>
  </a>
  <a *ngIf="api.getAccess('listhandbooks')" mat-flat-button routerLink="/handbooks/list">
    <mat-icon>library_books</mat-icon>
    <span class="nav-menu__link-text">Справочники</span>
  </a>
  <a *ngIf="api.getAccess('subscriptionsectionproducts')" mat-flat-button routerLink="/subscriptionsectionproducts">
    <mat-icon>subscriptions</mat-icon>
    <span class="nav-menu__link-text">Подписка</span>
  </a>
  <a *ngIf="api.getAccess('sharedhistory')" mat-flat-button (click)="sharedHistoryClick()">
    <mat-icon>history</mat-icon>
    <span class="nav-menu__link-text">История изменений</span>
  </a>
  <a *ngIf="api.getAccess('settings')" mat-flat-button (click)="showSettings()">
    <mat-icon>settings</mat-icon>
    <span class="nav-menu__link-text">Настройки</span>
  </a>
  <a *ngIf="!api.user || api.getAccess('subscriptionsectionproducts')" mat-flat-button routerLink="/instruction">
    <mat-icon>question_answer</mat-icon>
    <span class="nav-menu__link-text">Инструкция</span>
  </a>

  <ng-container *ngIf="devService.isDevMode">
    <button mat-flat-button color="warn"
      (click)="devService.socketsToggle()">{{devService.isSocketsOn ? 'Отключить' : 'Включить'}} сокеты</button>
  </ng-container>

</div>

<div class="nav-menu__footer">
  <div [ngClass]="{'nav-menu__links-list_hidden': toggle}" class="nav-menu__links-list">
    <a href="javascript:void(0)" class="nav-menu__link" routerLink="/agreement">Пользовательское соглашение</a>
    <a href="javascript:void(0)" class="nav-menu__link" routerLink="/policy">Политика обработки персональных данных</a>
  </div>
  <div class="nav-menu__toggle">
    <button mat-flat-button (click)="toggle = !toggle">
      <mat-icon>{{ toggle ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
    </button>
  </div>
</div>
